// extracted by mini-css-extract-plugin
export var btn_arrow = "OutlineButton-module--btn_arrow--d981e";
export var btn_icon = "OutlineButton-module--btn_icon--dc0db";
export var colored = "OutlineButton-module--colored--2addf";
export var gray = "OutlineButton-module--gray--c8e02";
export var outline_btn = "OutlineButton-module--outline_btn--8d386";
export var white = "OutlineButton-module--white--d8d7a";